import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { getUpdatePageLinks, useGetCampaignName } from '@occc-app/routes/CampaignComponents/utils';

import { RewardConfigureFormContainer } from '../components/RewardConfigureForm/RewardConfigureFormContainer';
import { messages } from '../messages';

export const RewardUpdatePageContainer: React.FC = () => {
  const { id: campaignId = '', rewardId = '' } = useParams<{ id: string; rewardId: string }>();

  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: rewardId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={rewardId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Reward}
      targetTabProps={{
        shouldShowStateRestrictions: false,
        shouldShowStoreLocationOrGroups: false,
      }}
      ConfigureFormContainer={RewardConfigureFormContainer}
    />
  );
};
